import { useEffect } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

/** Records the signed-in Google user. */
export const RegisterBackofficeUser = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const identityApi = useApi(identityApiRef);

  useEffect(() => {
    let cancelled = false;
    const register = async () => {
      const baseUrl = await discoveryApi.getBaseUrl('backoffice-auth');
      const profile = await identityApi.getProfileInfo();
      if (cancelled) return;
      await fetchApi.fetch(`${baseUrl}/me`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ displayName: profile.displayName }),
      });
    };
    register().catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [discoveryApi, fetchApi, identityApi]);

  return null;
};
